import React from "react";
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import { t } from "i18next";

import { StyledRichTextContainer } from "./RichTextBox.styled";

interface RichTextBox {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  onFocus?: () => void;
  onBlur?: () => void;
}

const RichTextBox: React.FC<RichTextBox> = ({
  value,
  onChange,
  placeholder,
  disabled,
  onFocus,
  onBlur,
}) => {
  return (
    <StyledRichTextContainer>
      <ReactQuill
        value={value}
        onChange={onChange}
        theme="snow"
        readOnly={disabled}
        placeholder={placeholder ? placeholder : t("richText.placeholder")}
        onFocus={onFocus}
        onBlur={onBlur}
      />
    </StyledRichTextContainer>
  );
};

export default RichTextBox;
